import styled from "styled-components";

const Header = styled.div`
  font-size: 1.2rem;
  color: ${({ theme }) => theme.text};
`;

export default Header;
